// extracted by mini-css-extract-plugin
export default {"tasks__list":"create-appointment_tasks__list__8BzoA","customer-refresh":"create-appointment_customer-refresh__kGNYy"};